<!-- DaysForm.vue - Add/Edit Days -->
<template>
    <div class="form-container">
        <h2>{{ isEditing ? 'Edit' : 'Add' }} Day</h2>
        <hr>

        <div v-if="errorMessage" class="error-message">
            <p>{{ errorMessage }}</p>
        </div>
        <form @submit.prevent="submitForm">
            <label>Day Name <span class="required">*</span></label>
            <input type="text" v-model="day.name" placeholder="Day Name" required>
            <div v-if="errors.name" class="error-message">{{ errors.name[0] }}</div>

            <div class="btn-group">
                <button type="submit" class="btn btn-sm">{{ isEditing ? 'Update' : 'Add' }}</button>
                <button type="button" class="btn btn-sm cancel-btn" @click="$router.push('/days')">Cancel</button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            day: { name: '' },
            isEditing: false,
            errorMessage: null,
            errors: {}
        };
    },
    methods: {
        async submitForm() {
            this.errorMessage = null;
            this.errors = {};
            try {
                if (this.isEditing) {
                    await this.$api.put(`/days/${this.$route.params.id}`, this.day);
                } else {
                    await this.$api.post('/days', this.day);
                }
                this.$router.push('/dashboard/days');
            } catch (error) {
                if (error.response?.status === 422) {
                    this.errors = error.response.data.errors;
                } else {
                    this.errorMessage = 'An error occurred while saving the day. Please try again later.';
                }
            }
        },
        async fetchDay() {
            if (this.$route.params.id) {
                this.isEditing = true;
                try {
                    const response = await this.$api.get(`/days/${this.$route.params.id}`);
                    this.day = { ...response.data };
                } catch (error) {
                    this.errorMessage = 'Error fetching day data.';
                }
            }
        }
    },
    mounted() {
        this.fetchDay();
    }
};
</script>

<style scoped>
.form-container {
    padding: 20px;
    background: white;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
</style>
